import styled, { css } from 'styled-components';

import {
  colors,
  cssBreakpoints,
  fontSizesByType,
  fontWeights,
  fonts,
  utilityClasses,
} from 'theme/theme';

export const rootStyles = css`
  font-family: ${fonts.sans};
  color: ${colors.mediumContentGrey};

  * {
    box-sizing: border-box;
    font-family: ${fonts.sans};
  }

  svg {
    box-sizing: content-box;
    pointer-events: none;
  }

  strong {
    font-weight: ${fontWeights.semiBold};
  }

  @page {
    margin-bottom: 0;
    size: auto;
    box-decoration-break: clone;
  }

  ${utilityClasses.map(
    (c) => css`
      .idlst-${c.name.replace(/[aeiou-]/g, '')} {
        ${c.styles}
      }
    `,
  )}
`;

export const Root = styled.div`
  font-size: ${fontSizesByType.body[0]}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    font-size: ${fontSizesByType.body[2]}px;
  }

  ${rootStyles};
`;
